import {
  GET_TAGS_PATH,
  GET_PROBLEM_DETAILS_NEW,
  GET_PROBLEM_METADATA,
  GET_PROBLEMS_FOR_NAVIGATION,
  GET_PROBLEMS_BY_ID,
  GET_VIDEO_URL,
} from "app/utils/constants/paths";
import jwtAuthAxios from "./auth/jwtAuth";

const problemServices = {};

problemServices.getProblemsForNavigation = async (
  page,
  size,
  orderBy,
  order,
  searchCriteria,
  problemName
) => {
  let url = `${GET_PROBLEMS_FOR_NAVIGATION}?page=${page}&size=${size}&sort=${orderBy},${order}`;

  if (searchCriteria && searchCriteria.length > 0) {
    const tagCriteria = searchCriteria.filter(
      (criterion) => !criterion.includes("=")
    );
    const adminCriteria = searchCriteria.filter((criterion) =>
      criterion.includes("=")
    );

    if (tagCriteria.length > 0) {
      const tagsParam = tagCriteria.map(encodeURIComponent).join(",");
      url += `&problemTags.in=${tagsParam}`;
    }

    if (adminCriteria.length > 0) {
      const adminParams = adminCriteria
        .map((criterion) => {
          const [keyOperator, value] = criterion.split("=");
          if (!keyOperator || !value) return "";
          return `${keyOperator}=${encodeURIComponent(value)}`;
        })
        .filter(Boolean)
        .join("&");
      if (adminParams) {
        url += `&${adminParams}`;
      }
    }
  }

  if (problemName) {
    url += `&defaultTitle.contains=${encodeURIComponent(problemName)}`;
  }

  try {
    const res = await jwtAuthAxios.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

problemServices.getProblemById = async (id) => {
  try {
    const { data } = await jwtAuthAxios.get(GET_PROBLEMS_BY_ID + `/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.getUniqueProblemTags = async () => {
  try {
    const { data } = await jwtAuthAxios.get(GET_TAGS_PATH);
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.getProblemDetails = async (name) => {
  try {
    const { data } = await jwtAuthAxios.get(
      GET_PROBLEM_DETAILS_NEW + `/${name}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.getProblemDetailsByName = async (name) => {
  try {
    const { data } = await jwtAuthAxios.get(
      GET_PROBLEM_DETAILS_NEW + `/${name}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.getProblemMetadata = async () => {
  try {
    const { data } = await jwtAuthAxios.get(GET_PROBLEM_METADATA);
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.updateProblem = async (problemData) => {
  try {
    const { data } = await jwtAuthAxios.put(GET_PROBLEMS_BY_ID, problemData);
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.createProblem = async (problemData) => {
  try {
    const { data } = await jwtAuthAxios.post(GET_PROBLEMS_BY_ID, problemData);
    return data;
  } catch (error) {
    throw error;
  }
};

problemServices.getVideoUrl = async (name) => {
  try {
    const data = await jwtAuthAxios.get(GET_VIDEO_URL + `/${name}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

export default problemServices;
